<template>
  <Base :base-id="'address-popup'" :base-class="'tab-action'">
    <template #header>
      <div class="modal-title">ADDRESS BOOK</div>
    </template>
    <template #body>
      <div v-for="data in modalData?.data" :key="data.ID" class="recipient-block">
        <div>
          <div class="recipient-wrap mb-4">
            <p class="recipient-title">收件資料 | Recipient Information ：</p>
            <span>{{ data.Name }}</span>
            <span class="mx-1">/</span>
            <span>{{ data.PhoneCountryCode }} {{ data.PhoneNumber }}</span>
          </div>
          <div class="recipient-wrap">
            <p class="recipient-title">配送地址 | Delivery Address ：</p>
            ({{ data.Country }})
            {{ data.Province }}
            {{ data.City }}
            {{ data.District }}
            {{ data.Address }}
          </div>
          <div class="recipient-wrap">
            <p>{{ data.CustomsClearanceID }}</p>
            <p>{{ data.Address2 }}</p>
            <p>{{ data.Address3 }}</p>
            <p>{{ data.Zip }}</p>
          </div>
        </div>
        <div class="btn-block">
          <a class="btn use-address" @click.prevent="use(data)">使用地址</a>
          <a class="delete-address" @click.prevent="deleteAddress(data.ID)">
            <i class="icon-circle-delete" />
          </a>
        </div>
      </div>
    </template>
  </Base>
</template>

<script setup>
import { storeToRefs } from 'pinia';

import useAlert from '@global/composable/useAlert';
import useModalStore from '@global/stores/useModalStore';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

import Base from '@global/components/common/modal/Base.vue';

const modalStore = useModalStore();
const { modalData } = storeToRefs(modalStore);
const { deleteAddressBookAPI } = useAxiosAPI();

const { alertDialog } = useAlert();

function deleteAddress(id) {
  deleteAddressBookAPI(id)
    .then((res) => {
      if (res.data.Code === 200) {
        const findDataIndex = modalData.value.data.findIndex((ele) => ele.ID === id);
        const filterData = modalData.value.data.filter((e) => {
          return id !== e.ID;
        });
        modalData.value = { delete: findDataIndex, data: filterData };
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

function use(data) {
  if (data.Country !== window.shippingRegion) {
    alertDialog.alert('地區與所選擇不同');
    return;
  }
  if (data.Province && data.Province !== window.shippingProvince) {
    alertDialog.alert('省份與所選擇不同');
    return;
  }
  modalData.value = { useAddress: data };
}
</script>
